import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const DeleteModal = (props) => {
    const { onHide, handleDelete, show } = props;

    return (
        <Modal show={show} onHide={onHide} size='sm' centered>
            <Modal.Body>Är du säker på att du vill ta bort uppdraget?</Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={props.onHide}>
                    Stäng
                </Button>
                <Button
                    variant='danger'
                    onClick={() => {
                        handleDelete();
                        onHide();
                    }}>
                    Ta bort
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteModal;
